"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const usa_modal_1 = __importDefault(require("@uswds/uswds/js/usa-modal"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("..");
const CloseIcon_1 = __importDefault(require("./CloseIcon"));
const ModalBody_1 = __importDefault(require("./ModalBody"));
const ModalFooter_1 = __importDefault(require("./ModalFooter"));
const ModalHeading_1 = __importDefault(require("./ModalHeading"));
const ModalComponent = ({ id, children, className, large, forceAction, labelledBy, describedBy, isOpen, onStateChanged }) => {
    const wrapperRef = (0, react_1.useRef)(null);
    const overlayRef = (0, react_1.useRef)(null);
    const openButtonRef = (0, react_1.createRef)();
    const closeButtonRef = (0, react_1.createRef)();
    const isOpenRef = (0, react_1.useRef)(isOpen);
    function closeModal(e) {
        if (e &&
            e.target !== overlayRef.current &&
            e.target !== closeButtonRef.current) {
            return;
        }
        usa_modal_1.default.toggleModal(new KeyboardEvent('keydown', { key: 'Escape' }));
    }
    (0, react_1.useEffect)(() => {
        const wrapperEl = wrapperRef.current;
        if (!wrapperEl)
            return;
        const closeButtons = wrapperEl.querySelectorAll('[data-close-modal]');
        closeButtons.forEach((button) => {
            button.setAttribute('aria-controls', id);
        });
        if (onStateChanged) {
            // use MutationObserver to watch if the modal state changes
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    const { target } = mutation;
                    const currentStatus = target.classList.contains('is-visible');
                    if (currentStatus !== isOpenRef.current) {
                        onStateChanged(currentStatus);
                    }
                });
            });
            observer.observe(wrapperEl, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }, [wrapperRef]);
    (0, react_1.useEffect)(() => {
        const wrapperEl = wrapperRef.current;
        const openButtonEl = openButtonRef.current;
        if (!onStateChanged || !wrapperEl || !openButtonEl)
            return;
        const modalStatus = wrapperEl.classList.contains('is-visible');
        if (isOpen === modalStatus)
            return; // do nothing if the status did not change
        if (isOpen) {
            openButtonEl.click(); // click the hidden button to open the modal
        }
        else {
            closeModal(); // close the modal
        }
    }, [wrapperRef, openButtonRef, isOpen, onStateChanged]);
    (0, react_1.useEffect)(() => {
        isOpenRef.current = isOpen;
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        return () => {
            // Account for URL change which will not close the modal
            const { body } = document;
            if (body.classList.contains('usa-js-modal--active')) {
                body.style.paddingRight = '0px';
                body.classList.remove('usa-js-modal--active');
                body.classList.remove('usa-js-no-click');
                const hiddenElements = document.querySelectorAll('[data-modal-hidden]');
                hiddenElements.forEach((element) => {
                    element.removeAttribute('data-modal-hidden');
                });
            }
        };
    }, []);
    // Create the modal in the top-level DOM node (<body>).
    // This is necessary because USWDS JS adds aria-hidden="true" to the root React div
    // whenever a modal is opened.
    return react_dom_1.default.createPortal((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [onStateChanged && ((0, jsx_runtime_1.jsx)(__1.Button, { "aria-hidden": "true", "aria-controls": id, "data-open-modal": true, ref: openButtonRef, style: { display: 'none' }, children: "Open modal" })), (0, jsx_runtime_1.jsx)("div", { id: id, className: (0, uswds_react_utils_1.createClassString)('usa-modal-wrapper is-hidden', className), role: "dialog", "aria-labelledby": labelledBy, "aria-describedby": describedBy, ...(forceAction && { 'data-force-action': forceAction }), ref: wrapperRef, children: (0, jsx_runtime_1.jsx)("div", { className: "usa-modal-overlay", onClick: closeModal, ref: overlayRef, children: (0, jsx_runtime_1.jsx)("div", { className: (0, uswds_react_utils_1.createClassString)('usa-modal', large && 'usa-modal--lg'), tabIndex: -1, children: (0, jsx_runtime_1.jsxs)("div", { className: "usa-modal__content", children: [(0, jsx_runtime_1.jsx)("div", { className: "usa-modal__main", children: children }), !forceAction && ((0, jsx_runtime_1.jsx)("button", { className: "usa-button usa-modal__close", type: "button", "aria-label": "Close this window", "aria-controls": id, onClick: closeModal, "data-close-modal": true, ref: closeButtonRef, children: (0, jsx_runtime_1.jsx)(CloseIcon_1.default, { className: "usa-icon", "aria-hidden": "true", focusable: "false", role: "img" }) }))] }) }) }) })] }), document.body);
};
const Modal = Object.assign(ModalComponent, { Body: ModalBody_1.default, Footer: ModalFooter_1.default, Heading: ModalHeading_1.default });
exports.default = Modal;
